import { take } from 'rxjs/operators';
import { ActivatedRouteSnapshot } from '@angular/router';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from './user';
import { UserService } from './user.service';

@Injectable()
export class UserResolver {
  constructor(private userService: UserService) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  resolve(route: ActivatedRouteSnapshot): Observable<User | null> {
    return this.userService.getUser().pipe(take(1));
  }
}
